import { jsx as s, Fragment as w, jsxs as L } from "react/jsx-runtime";
import { Children as _, useState as u, useRef as $, useEffect as z } from "react";
import G from "./components/Bullets.js";
import x from "./components/Arrows.js";
import { DefaultProps as k } from "./utils/defaultProps.js";
/* empty css                     */const X = ({
  children: S,
  id: m,
  bullet: c,
  arrow: r,
  qtyItems: l,
  gapItems: v = 4,
  itemWidthProp: a = 0,
  isMobile: p
}) => {
  const C = _.toArray(S), [A, W] = u(0), [g, D] = u(0), [E, M] = u(a), [F, I] = u(null), n = $(null), i = $(null), f = {
    bullets: {
      ...k.styles.bullets,
      ...c == null ? void 0 : c.style
    },
    arrows: {
      ...k.styles.arrows,
      ...r == null ? void 0 : r.style
    }
  }, h = () => {
    if (n.current) {
      const e = n.current.scrollWidth, t = n.current.scrollLeft, o = n.current.offsetWidth, d = Math.ceil(e / o), j = Math.round(t / (e / d) - 0.3) + 1;
      I(`${j}/${d}`);
    }
  }, Q = () => {
    if (n.current && i.current) {
      const e = i.current.clientWidth, t = n.current.scrollLeft, o = Math.round(t / e);
      D(o);
    }
  }, y = (e) => {
    if (n.current && i.current) {
      const t = i.current.clientWidth;
      e === "prev" && (n.current.scrollLeft -= t), e === "next" && (n.current.scrollLeft += t);
    }
  }, N = () => {
    if (n.current && i.current) {
      const e = i.current.clientWidth, t = n.current.offsetWidth, o = n.current.scrollWidth, d = Math.round((o - t) / e);
      W(l ? Math.ceil(C.length - l) : d);
    }
  }, R = (e) => {
    if (n.current && i.current) {
      const t = i.current.clientWidth;
      n.current.scrollLeft = t * e;
    }
  }, B = (e) => {
    if (n.current && a === 0) {
      const o = n.current.offsetWidth / e;
      M(o);
    }
  }, V = {
    width: `${a || (E < 150 ? 150 : 226)}px`
  };
  return typeof window < "u" && window.addEventListener("resize", () => {
    h(), N(), l && B(l);
  }), z(() => {
    var e;
    l && B(l), N(), h(), (e = n.current) == null || e.addEventListener("scroll", () => {
      h(), Q();
    });
  }, [n]), /* @__PURE__ */ s(w, { children: /* @__PURE__ */ L("div", { id: "carousel", "data-testid": "Carousel", children: [
    /* @__PURE__ */ L("div", { className: "carousel-content", children: [
      (r == null ? void 0 : r.isVisible) && /* @__PURE__ */ s("div", { className: "carousel-arrow-button-prev", children: /* @__PURE__ */ s(
        x,
        {
          position: "prev",
          style: f.arrows,
          iconColor: r.iconColor || "#ccc",
          onClick: () => y("prev")
        }
      ) }),
      /* @__PURE__ */ s(
        "div",
        {
          ref: n,
          className: "carousel-container",
          id: `carousel-container-tracking${m ? "-" + m : ""}`,
          children: C.map((e, t) => /* @__PURE__ */ s(
            "div",
            {
              className: "container-item",
              style: {
                ...V,
                transition: "all 0.5s  ease-out",
                marginRight: `${p ? 0 : v}px`,
                marginBottom: `${p ? v : 0}px`
              },
              ref: i,
              children: e
            },
            t
          ))
        }
      ),
      r != null && r.isVisible ? /* @__PURE__ */ s("div", { className: "carousel-arrow-button-next", children: /* @__PURE__ */ s(
        x,
        {
          position: "next",
          style: f.arrows,
          iconColor: r.iconColor || "#ccc",
          onClick: () => y("next")
        }
      ) }) : ""
    ] }),
    (c == null ? void 0 : c.numeric) && /* @__PURE__ */ s("div", { className: "numeric-bullets", children: F }),
    c != null && c.isVisible ? /* @__PURE__ */ s("div", { className: "bullets-container", children: Array.from({ length: A + 1 }, (e, t) => t + 1).map(
      (e, t) => /* @__PURE__ */ s(
        G,
        {
          onClick: () => {
            R(t);
          },
          index: t,
          style: {
            ...f.bullets,
            transition: "all 0.8s  ease-out",
            backgroundColor: `${g === t ? (c == null ? void 0 : c.bulletEnableColor) || "#ff0000" : (c == null ? void 0 : c.bulletDisableColor) || "#ccc"}`
          },
          isActive: g === t
        },
        t
      )
    ) }) : ""
  ] }) });
};
export {
  X as Carousel
};
